import { getInternalOrganizationDetailsApi } from '@/api/v1/organization/internal/getInternalOrganizationDetailsApi';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';
import {
  editInternalOrganizationDetailsApi,
  EditInternalOrganizationDetailsPayloadType,
} from '@/api/v1/organization/internal/editInternalOrganizationDetailsApi';
import { prepareBaseListApiParams } from '@/api/helpers/apiHelpers';
import { QueryParamsType } from '@/api/helpers/apiParamsHelpers';
import {
  AddInternalOrganizationUserRolePayloadType,
  addInternalOrganizationUserRoleApi,
} from '@/api/v1/organization/internal/addInternalOrganizationUserRoleApi';
import {
  CreateInternalOrganizationUserPayloadType,
  createInternalOrganizationUserApi,
} from '@/api/v1/organization/internal/createInternalOrganizationUserApi';
import { getInternalOrganizationUserAddingStatusApi } from '@/api/v1/organization/internal/getInternalOrganizationUserAddingStatusApi';
import { getInternalOrganizationUsersApi } from '@/api/v1/organization/internal/getInternalOrganizationUsersApi';

export const getInternalOrganizationDetails = async () => {
  try {
    const response = await getInternalOrganizationDetailsApi();

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const editInternalOrganizationDetails = async (payload: EditInternalOrganizationDetailsPayloadType) => {
  try {
    const response = await editInternalOrganizationDetailsApi(payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const getInternalOrganizationUsers = async (params: QueryParamsType) => {
  const apiParams = prepareBaseListApiParams(params);

  try {
    const response = await getInternalOrganizationUsersApi(apiParams);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const createInternalOrganizationUser = async (payload: CreateInternalOrganizationUserPayloadType) => {
  try {
    const response = await createInternalOrganizationUserApi(payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const addInternalOrganizationUserRole = async (payload: AddInternalOrganizationUserRolePayloadType) => {
  try {
    const response = await addInternalOrganizationUserRoleApi(payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const getInternalOrganizationUserAddingStatus = async (userId: string) => {
  try {
    const response = await getInternalOrganizationUserAddingStatusApi(userId);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
